<template>
   <div>
      <ddoCartArea :cart="cart" :callbacks="callbacks" :cart-sub-total="cartSubTotal" :tax="tax" :cart-total="cartTotal" :checkout-bool="checkoutBool" :options="options"/>
   </div>
</template>

<script>
   import Vue from 'vue';
   import i18n from '@/plugins/i18n.js';
   import ddoCartArea from '@/components/ddoCartArea.vue';
   export default {
      components: {
         ddoCartArea,
      },

      props: {
         callbacks: {},
         cart: {
            type: Array,
            default: function() {
               return [];
            }
         },
         options: {
            type: Array,
            default: function() {
               return [];
            }
         },
         cartSize: 0,
         cartSubTotal: 0,
         cartTotal: 0,
         tax: 0,
         checkoutBool: false,
      },

      data: function() {
         return {
            showModal: false
         }
      },
      
      created() {
      },

      methods: {

      },

   }
</script>